import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledEntityHeading = styled(Box)`
  display: flex;
  column-gap: ${props => props.theme.layout('1sp')};
  
  .EntityHeading {
    &-logo {
      .Badge {
        .MuiBadge-badge {
          .Icon {
            color: ${props => props.theme.property('palette.text.disabled')};
            margin-top: ${props => props.theme.layout(-1.25)};
            margin-right: ${props => props.theme.layout(-0.25)};
          }
        }
      }
    }
    
    &-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: fit-content;
      line-height: ${props => props.theme.lineHeight('1.2f')};
    }
    
    &-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 1px;
      flex-grow: 1;
    }

    &-actions {
      display: flex;
      column-gap: ${props => props.theme.layout(4)};
      margin-left: ${props => props.theme.layout(-2)};
      
      .Icon {
        color: ${props => props.theme.property('palette.text.secondary')};

        .HostnamesIcon-text {
          font-weight: bold;
          text-anchor: start;
        }
      }
    }
  }
  
  &.EntityHeading-isLoading {
    &:has(.EntityHeading-actions) {
      .EntityHeading {
        &-name {
          line-height: ${props => props.theme.lineHeight('1.2f')};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledEntityHeading.propTypes = {
  theme: PropTypes.object
};

export default StyledEntityHeading;
